import React, { useEffect, useState, useRef } from 'react'
import { Button, Card, Collapse, Popconfirm, Table, Tooltip,notification } from 'antd'
import { chooseEmailModalFxn, DisplayDate, GetDownloadLink } from '../../../../components/_utils/appUtils'
import { TableComp } from 'sz-react-utils-lite'
import _ from 'lodash'
// import ReceiveDateDrawer from '../reviewer/editSelectReceiveDate'
import { RowTable } from '../../../../containers/article/articleView/RowTable'
import AcceptanceAbstractDrawer from '../../views/abstractPages/AcceptanceAbstractDrawer'
import { useDispatch } from 'react-redux'
import { API_URL } from '../../../../request'
// import { SendTemplateEmail } from '../../../email/actions'
import { AcceptanceAbstract } from '../actions'

const { Panel } = Collapse

const AcceptedAbstractDetails = (props) => {
  let { abstract, onRefresh } = props
  let {
    approvedAbstractPaymentDate,
    acceptanceLetter,
    approvedAbstractDate
  } = abstract

  let [reviewerId, setReviewerId] = useState('')
  let headerTitle = `Accepted ${approvedAbstractPaymentDate ? `(${DisplayDate(approvedAbstractPaymentDate)})` : ''}`
  let [visibleAcceptanceDrawer, setVisibleAcceptanceDrawer] = useState(false)
  const table = useRef()
  let dispatch = useDispatch()

  let events = {
    reloadTable: () => {
      if (onRefresh) onRefresh()
    },
    showAndHideReceiveDate: (value, id = '') => {
      setVisibleAcceptanceDrawer(value)
      setReviewerId(id)
    },
    show: () => {
      setVisibleAcceptanceDrawer(true)
    },
    hide: () => {
      setVisibleAcceptanceDrawer(false)
      if (onRefresh) onRefresh()
    }
  }

  let BtnAction = (event) => {
    events.show()
    event.stopPropagation()
  }

  // let resendAcceptedAbstractDetails = (event) => {
  //   event.stopPropagation()
  //   chooseEmailModalFxn({
  //     callback: async (email) => {
  //       let obj = {
  //         id: abstract._id,
  //         fromEmail: email,
  //         template: abstract.approvedAbstractPayment > 0 ? 'acceptanceAbstract' : 'acceptanceAbstractWithoutCharges',
  //         type: 'abstract',
  //         attachmentArr: ['acceptanceLetter']
  //       }
  //       let resp = await dispatch(SendTemplateEmail({
  //         email: obj.fromEmail,
  //         id: abstract._id,
  //         obj,
  //         template: obj.template
  //       }))
  //       if (resp && resp.success) {
  //         if (onRefresh) onRefresh()
  //       }
  //     }
  //   })
  // }
  let resendAcceptedAbstractDetails = (event) => {
    event.stopPropagation();

    chooseEmailModalFxn({
      callback: async (email) => {
        // 1. Prepare payload exactly like your handleSubmit
        const valData = {
          abstractId: abstract._id,
          fromEmail: email,
          approvedAbstractPayment: abstract.approvedAbstractPayment || abstract.publicationCharges || 0,
          status: 'Accepted Abstract',
          isUpdate: true,
          sendEmail: true
        };

        // 2. Logic for template (Same as your handleSubmit)
        valData.template = valData.approvedAbstractPayment > 0
          ? 'acceptanceAbstract'
          : 'acceptanceAbstractWithoutCharges';

        // 3. Dispatch the SAME action
        let { success } = await dispatch(AcceptanceAbstract(valData));

        if (success) {
          notification.success({
            message: 'Success',
            description: 'Acceptance email resent successfully.'
          });

          // Refresh the list to reflect any potential updates
          dispatch({ type: 'START_LOAD_ABSTRACT' });

          if (onRefresh) {
            onRefresh();
          }
        }
      }
    });
  };
  let downloadAcceptedAbstract = (event) => {
    event.stopPropagation()
    window.open(abstract.acceptanceLetter.path, '_blank')
  }

  let getExtraButton = () => {
    return (
      <React.Fragment>
        {abstract.acceptanceLetter && abstract.acceptanceLetter.path ?
          <Button type={'primary'} size={'small'} className={'mr-5'} onClick={downloadAcceptedAbstract}>
            Acceptance Letter
          </Button> : null}

        {approvedAbstractDate && !approvedAbstractPaymentDate ?
          <Button type={'primary'} size={'small'} onClick={BtnAction}>Add</Button> : null}

        {approvedAbstractPaymentDate ?
          <Button type={'primary'} size={'small'} onClick={BtnAction}>Edit</Button> : null}

        {abstract.approvedAbstractPaymentDate && abstract.status === 'Accepted Abstract' ?
          <Button type={'primary'} size={'small'} onClick={resendAcceptedAbstractDetails} className={'ml-5'}>
            Resend Acceptance Letter
          </Button> : null}
      </React.Fragment>
    )
  }

  return (
    <div>
      <Collapse expandIconPosition={'right'} defaultActiveKey={['1']}>
        <Panel header={headerTitle} key='1' extra={getExtraButton()}>
          <div className={'tableBox striped'}>
            <RowTable title={'Date'} value={
              approvedAbstractPaymentDate && DisplayDate(approvedAbstractPaymentDate)
            }/>
            {/*<RowTable title={'Approval Status'} value={*/}
            {/*  abstract.approvedAbstractPayment ? `${abstract.currencyTypeOfApprovalAmount || ''} ${abstract.approvedAbstractPayment}` : null*/}
            {/*}/>*/}
            <RowTable title={'Mode Of Payment'} value={
              abstract.approvedAbstractPaymentMode ? abstract.approvedAbstractPaymentMode : null
            }/>
            <RowTable title={'Other Description'} value={
              abstract.approvedAbstractPaymentDiscription ? abstract.approvedAbstractPaymentDiscription : null
            }/>
            <RowTable title={'Acceptance Letter'} value={
              acceptanceLetter && acceptanceLetter.path ?
                <a download className='downloadLink' target={'_blank'} rel="noopener noreferrer"
                   href={acceptanceLetter.path}>Download</a> : 'No Attachment'
            }/>
          </div>
        </Panel>
      </Collapse>

      {visibleAcceptanceDrawer ? (
        <AcceptanceAbstractDrawer
          visible={visibleAcceptanceDrawer}
          abstractId={abstract._id}
          abstract={abstract}
          edit={!!approvedAbstractPaymentDate}
          onClose={() => events.hide()}
          callback={onRefresh}
        />
      ) : null}
    </div>
  )
}

export default AcceptedAbstractDetails